module.exports = __webpack_public_path__ + "img/3.47b7bc5c.png";